import { JuloUpdateEntry } from "./types"

export const snabbAtgardsinmatningEntry: JuloUpdateEntry = {
  slug: "2026-05-13-snabb-atgardsinmatning",
  date: "2026-05-13",
  title: "Snabbare sätt att lägga in åtgärder i mottagningen",
  description:
    'Nu använder alla det nya, snabbare sättet att lägga in åtgärder i mottagningen — en sökdriven rad där ni kan slå in komponentåtgärder, paket, tvätt, dämparservice och avgifter direkt, eller filtrera på en kategori. Rabatt, kommentar och produkter (med EAN-sök eller streckkodsskanning) ligger inline på varje rad. Den gamla varianten med separata kort för Tvätt, Paket och Serviceförslag är borttagen, och inställningen "Skapande av preliminärt serviceförslag" finns inte längre under [Inställningar → Mottagning](/settings/reception).',
  images: [
    {
      src: "/julo-updates/2026-05-13-snabb-atgardsinmatning/serviceforslag.png",
      alt: "Serviceförslag-vyn i mottagningen med tre inmatade rader (Miljöavgift 15 kr, Förbrukningsavgift 20 kr och komponentåtgärden Byt kedja 309 kr med en -25 % rabatt → 232 kr, samt fält för kommentar och EAN/produktnamn) och en aktiv sökrad märkt Åtgärd med kategoriknapparna Paket, Dämparservice, Tvätt, Avgift och Komponentåtgärd, där förslagslistan visar paketen Däck- och slangbyte fram (300 kr) och Grundservice brons (700 kr).",
    },
  ],
}
